import React from 'react';
import clsx from 'clsx';

import { type FieldProps } from '@/stories/components/Form/Input/Input';
import dpe from '@/stories/components/DpeGraph/dpe-graph.module.css';
import styles from './dpe.module.css'
import { Count } from '@/stories/atoms/Count/Count';

export type CheckboxProps = React.ComponentProps<'input'> & Omit<FieldProps, "label"> & {
  label: string,
  count?: number
}

export const Dpe = ({label, id, name, value, count, required = false, checked, ...props}: CheckboxProps) => {

  return (
    <label htmlFor={id} className={clsx(styles.label, dpe.item, count === 0 && styles.disabled)} style={
      {
        '--bg-color': `var(--dpe-conso-${label.toLocaleLowerCase()})`,
        '--fg-color': `var(--dpe-conso-fg-${label.toLocaleLowerCase()})`
      } as React.CSSProperties}>
      <input type='checkbox' id={id || name} value={value} checked={checked} {...props} required={required}/>
      <span className={dpe.etiquette}>{label}</span>
      {count ? <Count value={count} variant='secondary'/> : null}
    </label>
  )
};
